import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';

// components
import EmptyTable from './EmptyTable';

// internal
import {
  get_directory_slug,
} from '../election-utils';


const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any };
  notes: { [key: string]: any };
  columnCount: number;
  contestTitle: string;
  renderParty: any;
  renderCandidate: any;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      isShowcaseRace,
      redistrictingNote,
      notes,
      renderParty,
    } = this.props;

    const onePrimary = contest.length == 1;

    let onePrimaryParty; 

    if (onePrimary) {
      onePrimaryParty = contest[0].party
    }


    // The Republic API slugs don't match the directory url slugs so we need to get them

    let directory_slug;

    const IsNoted = notes && notes.length > 0 ? true : false;
    
    if (contest[0]) {
      directory_slug = get_directory_slug(contest[0].office);
    }


    return (
      <div class="seat">
        
         {!isShowcaseRace && contest && (
              <h3 class="seat__title">
                <span>{contestTitle}</span>
                {/* Let's not show U.S. House directory links because the redistricting boundaries have changed and will be reflected in our directory in 2027 */}
                {directory_slug[0] != null && contest[0].office != 'U.S. House'  && (
              <a class="t-links-unset"
                href={`https://directory.texastribune.org/districts/${directory_slug[0]['directory-slug']}/${contest[0]['office_division']}/`}
              >
                <span class="icon-div" title="Click to learn more about this district">
                  <svg class="icon icon-info">
                    <use xlinkHref="#icon-info"></use>
                  </svg>
                </span>
              </a>
            )}
            {redistrictingNote && contest && (
              <div class="redistrictingNote">Newly drawn <a href="https://www.texastribune.org/2025/09/04/2025-texas-redistricting-maps/">in 2025</a></div>
            )}
              </h3>
              
            )}
            
        <div class='seat__races'>
          {onePrimary && onePrimaryParty == 'Republican' && (
            <EmptyTable party={'Democrat'}/>       )}
          {contest.map((party: any, index) => renderParty(party, index))}
          {onePrimary && onePrimaryParty == 'Democrat' && (
            <EmptyTable party={'Republican'}/>       )}
        </div>
        {IsNoted == true && (
            <p class="note__text note__text__both-parties">{converter.convert(notes[0].value)}</p>
          )}
      </div>
      
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
};

export default Contest;